import { createApi } from '@reduxjs/toolkit/query/react';
import { API_CONFIG } from '../api/config/constants';

import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { logout } from './auth/authSlice';

const baseQuery = fetchBaseQuery({
  baseUrl: API_CONFIG.BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token;
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

export const baseQueryWithReauth = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  if (result?.error?.status === 401) {
    api.dispatch(logout());
  }

  return result;
};

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['User', 'Surgeon', 'Subscription', 'Region', 'Province', 'City', 'Clinic', 'Reviews'],
  endpoints: () => ({}),
});

export const { useGetUserQuery } = apiSlice;
